module.exports = __webpack_public_path__ + "static/img/14000778.6f570905.png";